export default {
  title: 'Choose a package for your',
  title_light: ' operating BV',
  description:
    'Get benefits with a package for your operating BV. Save money and time with 100+ contracts and legal advice from lawyers.'
};
